const LABELS_WHISP = {
  1: 'Alto',
  2: 'Medio',
  3: 'Bajo',
  4: 'Falta información',
  5: 'Sin asignar',
};

export default LABELS_WHISP;
